module.exports = __webpack_public_path__ + "static/img/wealth_level_98.5139d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_98.png
// module id = xXrP
// module chunks = 0